import { useEffect, useState } from 'react';
import { getQuestions } from '../../services/selfcheckin.service';
import CheckinQuestionsCorporateRouter from './chekinQuestionsRouterDabur';

export const daburQuestionaire = [
  {
    'id': 'p1',
    'index': 1,
    'title': 'What is your age group?',
    'options': { 'Below 25 years': 'Below 25 years', '25-35 years': '25-35 years', '36-45 years': '36-45 years', 'Above 45 years': 'Above 45 years' },
  },
  {
    'id': 'p2',
    'index': 2,
    'title': 'What is your gender?',
    'options': { 'Female': 'Female', 'Male': 'Male', 'Other': 'Other', 'Prefer not to say': 'Prefer not to say' },
  },
  {
    'id': 'p3',
    'index': 3,
    'title': 'What is your zone?',
    'options': {
      'Kaushambi Corporate': 'Kaushambi Corporate',
      'DRDC': 'DRDC',
      'North Zone': 'North Zone',
      'West Zone': 'West Zone',
      'Central Zone': 'Central Zone',
      'South Zone': 'South Zone',
      'East Zone': 'East Zone'
    },
  },

  {
    'id': 's1',
    'index': 4,
    'heading': 'Rate on the scale of 1 to 5 (1- strongly disagree and 5- strongly agree)',
    'title': 'I feel confident about my future',
    'options': {
      '1 - strongly disagree':1,
      '2 - disagree':2,
      '3 - neutral':3,
      '4 - agree':4,
      '5 - strongly agree':5
    },
    'scoring':true,
  },


  {
    'id': 's2',
    'index': 5,
    'heading': 'Rate on the scale of 1 to 5 (1- strongly disagree and 5- strongly agree)',
    'title': 'I often find joy in the things I do',
    'options': {
      '1 - strongly disagree':1,
      '2 - disagree':2,
      '3 - neutral':3,
      '4 - agree':4,
      '5 - strongly agree':5
    },
    'scoring':true,
  },

  {
    'id': 's3',
    'index': 6,
    'heading': 'Rate on the scale of 1 to 5 (1- strongly disagree and 5- strongly agree)',
    'title': 'I feel healthy overall',
    'options': {
      '1 - strongly disagree':1,
      '2 - disagree':2,
      '3 - neutral':3,
      '4 - agree':4,
      '5 - strongly agree':5
    },
    'scoring':true,
  },

  {
    'id': 's4',
    'index': 7,
    'heading': 'Rate on the scale of 1 to 5 (1- strongly disagree and 5- strongly agree)',
    'title': 'I feel connected to others',
    'options': {
      '1 - strongly disagree':1,
      '2 - disagree':2,
      '3 - neutral':3,
      '4 - agree':4,
      '5 - strongly agree':5
    },
    'scoring':true,
  },

  {
    'id': 's5',
    'index': 8,
    'heading': 'Rate on the scale of 1 to 5 (1- strongly disagree and 5- strongly agree)',
    'title': 'I have a clear sense of meaning and purpose in life',
    'options': {
      '1 - strongly disagree':1,
      '2 - disagree':2,
      '3 - neutral':3,
      '4 - agree':4,
      '5 - strongly agree':5
    },
    'scoring':true,
  },

  {
    'id': 's6',
    'index': 9,
    'heading': 'Rate on the scale of 1 to 5 (1- strongly disagree and 5- strongly agree)',
    'title': 'I manage my worries well',
    'options': {
      '1 - strongly disagree':1,
      '2 - disagree':2,
      '3 - neutral':3,
      '4 - agree':4,
      '5 - strongly agree':5
    },
    'scoring':true,
  },

  {
    'id': 's7',
    'index': 10,
    'heading': 'Rate on the scale of 1 to 5 (1- strongly disagree and 5- strongly agree)',
    'title': 'I receive the social and emotional support I need',
    'options': {
      '1 - strongly disagree':1,
      '2 - disagree':2,
      '3 - neutral':3,
      '4 - agree':4,
      '5 - strongly agree':5
    },
    'scoring':true,
  },


  {
    'id': 's8',
    'index': 11,
    'heading': 'Rate on the scale of 1 to 5 (1- strongly disagree and 5- strongly agree)',
    'title': 'I actively maintain close relationships',
    'options': {
      '1 - strongly disagree':1,
      '2 - disagree':2,
      '3 - neutral':3,
      '4 - agree':4,
      '5 - strongly agree':5
    },
    'scoring':true,
  },


  {
    'id': 's9',
    'index': 12,
    'heading': 'Rate on the scale of 1 to 5 (1- strongly disagree and 5- strongly agree)',
    'title': 'I feel a sense of accomplishment in my work',
    'options': {
      '1 - strongly disagree':1,
      '2 - disagree':2,
      '3 - neutral':3,
      '4 - agree':4,
      '5 - strongly agree':5
    },
    'scoring':true,
  },


  {
    'id': 's10',
    'index': 13,
    'heading': 'Rate on the scale of 1 to 5 (1- strongly disagree and 5- strongly agree)',
    'title': 'I am satisfied with my overall quality of life',
    'options': {
      '1 - strongly disagree':1,
      '2 - disagree':2,
      '3 - neutral':3,
      '4 - agree':4,
      '5 - strongly agree':5
    },
    'scoring':true,
  },
]

const SelfCheckinQuestionaireCorporate = () => {
  const [questions, setQuestions] = useState();
  useEffect(() => {
    getCheckinQuestions();
  }, []);

  const getCheckinQuestions = async () => {
    const data = daburQuestionaire as any;
    setQuestions(data);
  };

  if (questions != null) {
    return <CheckinQuestionsCorporateRouter questions={questions} />;
  } else {
    return <div>Loading....</div>;
  }
};
export default SelfCheckinQuestionaireCorporate;
